<!-- app页面——我的回收站 -->
<template>
  <div class="myRecycleH5">
    <van-nav-bar title="回收站" left-arrow @click-left="toBack" />
    <div class="content">
      <!-- 文档列表 -->
      <van-pull-refresh v-model="refreshing" v-loading="loading" class="folderList" @refresh="onRefresh">
        <div v-for="item in myRecycleList" :key="item.folderId" class="folderItem">
          <oneFileFolder :key="item.folderId" :item="item" @moreOpen="moreOpen(item)"></oneFileFolder>
        </div>
        <div v-if="!myRecycleList.length" class="empty">暂无数据</div>
      </van-pull-refresh>
    </div>

    <!-- 更多弹框 -->
    <myRecycleMore ref="myRecycleMore" @toRefresh="toRefresh" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";
import oneFileFolder from "../../components/oneFileFolder.vue";
import myRecycleMore from "./myRecycleMore.vue";

export default {
  components: { oneFileFolder, myRecycleMore },
  data() {
    return {
      myRecycleList: [], // 我的回收站列表
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getMyRecycleList();
  },
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },

    // 获得我的回收站列表
    async getMyRecycleList() {
      this.loading = true;
      try {
        const enterpriseId = this.enterpriseId;
        const res = await docService.querypersonalRecycle(enterpriseId);
        this.myRecycleList = res.data || [];
      } finally {
        this.loading = false;
      }
    },
    // 刷新列表
    toRefresh() {
      this.getMyRecycleList();
    },
    // 下拉刷新
    async onRefresh() {
      try {
        await this.getMyRecycleList();
      } finally {
        this.refreshing = false;
      }
    },

    // 点击... 打开更多
    moreOpen(item) {
      if (item.isFolder === 1) this.$refs.myRecycleMore.setFolderPrivi(item);
      else this.$refs.myRecycleMore.setFilePrivi(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.myRecycleH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
  }
}

.folderList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--info-color)9;
    font-size: 16px;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
